import { Factory } from 'rosie';

Factory.define('SearchAggregations');



// WEBPACK FOOTER //
// ./factories/search_aggregations_factory.js